import {Routes} from '@angular/router';

const APP_ROUTES: Routes = [
	{
		path: 'census-search',
		loadChildren: () =>
			import('./features/census-search/census-search-routes').then(m => m.CENSUS_SEARCH_ROUTES), // lazy loading standalone components
	}
];

export {
	APP_ROUTES
}
